
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/public/page/[id]",
      function () {
        return require("private-next-pages/cases/public/page/[id].tsx");
      }
    ]);
  